"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertModalPosition = exports.AlertModal = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atoms_1 = require("../../atoms");
const AlertModalPosition_1 = require("./AlertModalPosition");
Object.defineProperty(exports, "AlertModalPosition", { enumerable: true, get: function () { return AlertModalPosition_1.AlertModalPosition; } });
const AlertModal_styles_1 = require("./AlertModal.styles");
const AlertModal = ({ visible = true, title, message, actionButtonText, HeaderIcon, onActionButtonPress, position = AlertModalPosition_1.AlertModalPosition.BOTTOM, }) => {
    return (react_1.default.createElement(react_native_1.Modal, { animationType: "slide", transparent: true, visible: visible, onRequestClose: onActionButtonPress, testID: "bottom-sheet-modal" },
        react_1.default.createElement(AlertModal_styles_1.Overlay, { modalPosition: position },
            react_1.default.createElement(AlertModal_styles_1.Container, { modalPosition: position },
                HeaderIcon && (react_1.default.createElement(AlertModal_styles_1.StyledModalHeaderIcon, null,
                    react_1.default.createElement(HeaderIcon, null))),
                react_1.default.createElement(AlertModal_styles_1.HeadingContainer, null,
                    react_1.default.createElement(AlertModal_styles_1.StyledHeading3, { testID: "alertModalHeading" }, title)),
                react_1.default.createElement(AlertModal_styles_1.MessageContainer, null,
                    react_1.default.createElement(AlertModal_styles_1.StyledPText, { type: atoms_1.PTextType.VALUE }, message)),
                react_1.default.createElement(AlertModal_styles_1.ButtonContainer, null,
                    react_1.default.createElement(atoms_1.Button, { testID: "bottom-modal-action-button", type: atoms_1.ButtonAction.PRIMARY, onPress: onActionButtonPress, size: atoms_1.ButtonSize.DEFAULT }, actionButtonText))))));
};
exports.AlertModal = AlertModal;
